import toString from "lodash-es/toString";

const faAlphabet = "ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیَُِ‌آاً";
const arAlphabet = `${faAlphabet}ًٌٍَُِّْٰٔءك‌ةۀأإيـئؤ،`;

export const isRtl = (string: unknown) =>
  // eslint-disable-next-line no-misleading-character-class
  new RegExp(`[${arAlphabet}]`).test(toString(string));
